import { EERIE } from 'HubStyleTokens/colors';
import UIIcon from 'UIComponents/icon/UIIcon';
import DataTokenPopover from 'automation-ui-formula-editor/data-passing-panel/Inputs/DataPropertyPopoverMenu/DataTokenPopover';
import DataTokenPopoverPortal from 'automation-ui-formula-editor/data-passing-panel/Inputs/DataPropertyPopoverMenu/DataTokenPopoverPortal';
import DataTokenPopoverWrapper from 'automation-ui-formula-editor/data-passing-panel/Inputs/DataPropertyPopoverMenu/DataTokenPopoverWrapper';
import DataTokenMarkTag from 'automation-ui-formula-editor/formula-editor/data-tag-mark/DataTokenMarkTag';
import { useRef, useState } from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
export const FormulaEditorTokenTag = ({
  'data-test-id': dataTestId = 'formula-editor-token',
  closeable,
  inline = true,
  label,
  onClickRemoveToken,
  onClickScrollToToken,
  onClickSearchForToken,
  onCloseClick,
  propertyIconName,
  readOnly,
  TooltipContent,
  use,
  useError,
  verticalAlign
}) => {
  const dataTokenRef = useRef(null);
  const [displayPopover, setDisplayPopover] = useState(false);
  const hasTooltip = !!TooltipContent;
  const getIcon = () => {
    if (useError) {
      return /*#__PURE__*/_jsx(UIIcon, {
        className: "m-left-1 m-y-0",
        name: "warning"
      });
    } else if (hasTooltip) {
      return /*#__PURE__*/_jsx(UIIcon, {
        className: "m-left-1",
        color: EERIE,
        name: "info"
      });
    }
    return null;
  };
  return /*#__PURE__*/_jsx(_Fragment, {
    children: /*#__PURE__*/_jsx(DataTokenMarkTag, {
      closeable: closeable,
      "data-test-id": dataTestId,
      inline: inline,
      isActive: displayPopover,
      isError: !!useError,
      label: label,
      onClick: TooltipContent && !readOnly ? event => {
        event.stopPropagation();
        event.preventDefault();
        setDisplayPopover(true);
      } : undefined,
      onCloseClick: onCloseClick,
      propertyIconName: propertyIconName,
      ref: dataTokenRef,
      rightIcon: getIcon(),
      use: use,
      verticalAlign: verticalAlign,
      children: displayPopover && /*#__PURE__*/_jsx(DataTokenPopoverPortal, {
        displayPopover: displayPopover,
        onUnmount: () => setDisplayPopover(false),
        children: /*#__PURE__*/_jsx(DataTokenPopoverWrapper, {
          dataTokenRef: dataTokenRef,
          onClose: () => setDisplayPopover(false),
          children: /*#__PURE__*/_jsx(DataTokenPopover, {
            DataTokenInfoContent: TooltipContent,
            onClickRemoveToken: onClickRemoveToken,
            onClickScrollToToken: onClickScrollToToken,
            onClickSearchForToken: onClickSearchForToken
          })
        })
      })
    })
  });
};
export default FormulaEditorTokenTag;